import { render, staticRenderFns } from "./revenueshare.vue?vue&type=template&id=e12ef884&"
import script from "./revenueshare.vue?vue&type=script&lang=js&"
export * from "./revenueshare.vue?vue&type=script&lang=js&"
import style0 from "./revenueshare.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports